import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getArticle } from 'api/Blog';

export const fetchArticle = createAsyncThunk(
    'fetchArticle',
    async params => {
        const response = await getArticle(params);
        return response.data;
    },
    {
        // condition: (params, { getState }) => {
        //     const { jobsState } = getState();
        //     if (jobsState.jobs.hasOwnProperty(params.slug)) return false;
        // },
    },
);

const articlesSlice = createSlice({
    name: 'articlesState',
    initialState: {
        articles: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchArticle.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchArticle.fulfilled, (state, action) => {
                state.loading = false;
                const newArticleKey = action.payload.data.slug;

                const newArticle = {
                    [newArticleKey]: action.payload.data,
                };

                state.articles = {
                    ...state.articles,
                    ...newArticle,
                };
            })
            .addCase(fetchArticle.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default articlesSlice.reducer;
